import { memo } from 'react';
import { TextMessageBubble, Translation, TranslatedStatus } from 'components/Dialogue';
import EnhanceText from 'components/Dialogue/components/Message/EnhanceText';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { getMetaFromSender } from '../../utils';
import { useChatContext } from '../../contexts/ChatContext';
import { useGetTranslation } from './TextMsg';
import { BaseMsgProps } from './types';

export const JolectFormMsg = memo((props: BaseMsgProps) => {
  const { msg, raw } = props;
  const { singleTransToSysLang } = useChatContext();
  const { getTranslation } = useGetTranslation();
  const content = msg.content as Conversation.MsgJlForm | undefined;
  const { text, fields, submitted } = content || {};
  // 只有表单文本参与翻译，买家填单内容（fields）不翻译
  const translation = getTranslation(content?.translationContent);

  if (!text && !(submitted && fields?.length)) {
    return null;
  }

  const { layout, color } = getMetaFromSender(msg.sender);

  return (
    <MessageExtendComplex
      {...props}
      showSourceContent={false}
      content={
        <div className="flex flex-col gap-2">
          {text ? (
            <TextMessageBubble
              color={color}
              className={layout}
              extra={
                raw.hideTranslate ? null : (
                  <>
                    <Translation msg={raw} layout={layout} translation={translation} />
                    <TranslatedStatus
                      onTranslate={() => singleTransToSysLang(raw)}
                      status={
                        translation && !translation.text && translation.status === 'success'
                          ? 'error'
                          : translation?.status
                      }
                      translated={translation?.translated}
                    />
                  </>
                )
              }
            >
              <EnhanceText text={text} platform={raw.channel} />
            </TextMessageBubble>
          ) : null}
          {submitted && fields?.length ? (
            <div className="flex flex-col gap-2 p-2 bg-[#E3EDFF] rounded max-w-[520px]">
              {fields.map((field) => (
                <div key={field.name} className="flex gap-2 items-center">
                  <div className="text-xs text-[var(--fett-text-tertiary)]">{field.label}</div>
                  <div className="text-sm text-[var(--fett-text-primary)] break-all">
                    <EnhanceText text={field.text} platform={raw.channel} />
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      }
    />
  );
});
